module.exports = __webpack_public_path__ + "img/dsci0007.5f63ad58.jpg";